<template class="orderStatusSelector oss">
  <b-form-group
    :label="labelText"
    label-for="orderStatusFilter"
  >
    <v-select
      id="orderStatusFilter"
      :value="selectedOrderStatus"
      label="DisplayName"
      class="filter disableClear oss____status-selector"
      :options="orderStatusOptions"
      :select-on-tab="true"
      @input="SelectOrderStatus"
      :filter="FuseSearch"
    />
  </b-form-group>
</template>

<script>
  import vSelect from "vue-select"
  import Fuse from "fuse.js"
  import { OrderStatus } from "@/types/OrderStatus";

  export default {
    components: {
      vSelect
    },
    data: () => ({
      orderStatusOptions: [],
      selectedOrderStatus: "",
      initialOrderStatus: Object
    }),
    computed: {
      labelText() {
        return "Order Status";
      }
    },
    created () {
      this.orderStatusOptions = this.GetOrderStatuses();
      if (this.orderStatusOptions.length > 0) {
        this.selectedOrderStatus = this.orderStatusOptions[0].DisplayName;
      }
    },
    methods: {
      SelectOrderStatus(selectedOrderStatus) {
        this.$emit("selectOrderStatus", selectedOrderStatus);
      },
      GetOrderStatuses() {
        return Object.keys(OrderStatus).map(key => ({
          Code: key,
          DisplayName: OrderStatus[key]
        }));
      },
      FuseSearch(options, search){
        const fuse = new Fuse(options, {
          keys: [ 'DisplayName', 'Code' ],
          shouldSort: true,
          includeMatches: true,
          threshold: 1.0
        });
        let searchResult = search.length 
          ? fuse.search(search).map(({ item }) => item)
          : fuse.list;
        return searchResult;
      }
    },
  }
</script>
<style lang="scss">
  @media (min-width: $screen-md-max){
    .oss____status-selector ul{
      min-width: 800px !important;
    }
  }

  @media (max-width: $screen-sm-max){
    .oss____status-selector{
      max-width: 82vw;
      min-width: 50vw;
    }
      
    .oss____status-selector ul{
      max-width: 82vw;
      min-width: 50vw;
    }
  }
</style>
